// extracted by mini-css-extract-plugin
module.exports = {"operationItem":"index_operationItem__3KZRK"};